
<modal-search></modal-search>
<modal-product></modal-product>
<modal-share></modal-share>
<modal-auth></modal-auth>
<modal-info></modal-info>
<modal-review></modal-review>
<modal-contact></modal-contact>

<router-outlet></router-outlet>